import { columns } from './constants'
import { GameProviderWithBannerListTableData } from '@/modules/game/type'
import { SortableTable } from '@/common/ui/table/sortable-table'
import { SortableRow } from './SortableRow'
import { toast } from 'sonner'
import { useQueryClient } from '@tanstack/react-query'
import { GameQueryKeys } from '@/modules/game/keys'
import useMutationUpdateGameTypeProvider from '@/modules/game/api/hooks/useMutationUpdateGameTypeProvider'
import ProviderGameTypeSelector from '@/common/components/ProviderGameTypeSelector'
import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import BatchAssignRtpPreset from './components/BatchAssignRtpPreset'

interface ProviderListTableProps {
	data: GameProviderWithBannerListTableData[]
	total: number
	isLoading: boolean
}

export default function ProviderListTable({
	data,
	total,
	isLoading,
}: ProviderListTableProps) {
	const { mutateAsync: updateProvider } = useMutationUpdateGameTypeProvider()
	const queryClient = useQueryClient()

	const handleOrderChange = async (
		_newData: GameProviderWithBannerListTableData[],
		movedItem: GameProviderWithBannerListTableData,
		newIndex: number,
	) => {
		await updateProvider({
			id: movedItem.id,
			payload: {
				order: newIndex + 1,
			},
		})
		queryClient.invalidateQueries({
			queryKey: [GameQueryKeys.GetGameProviderList],
		})
		toast.success('อัพเดทลำดับสำเร็จ')
	}

	return (
		<div className="space-y-4 py-4">
			<div className="flex flex-wrap items-center justify-between gap-2">
				<div className="flex flex-wrap items-center gap-2">
					<DataTableSearch placeHolder="ค้นหาค่ายเกม" />
					<DataTableResetFilter />
					<BatchAssignRtpPreset />
				</div>
				<ProviderGameTypeSelector />
			</div>
			<SortableTable
				data={data}
				columns={columns}
				onOrderChange={handleOrderChange}
				SortableRowComponent={SortableRow}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
